export default __webpack_public_path__ + "static/media/paused-sub-bg.0492fef8.png";